import React, { useState } from "react";
import {
  Route,
  Switch,
  Redirect,
  useHistory,
  useLocation,
} from "react-router-dom";
import { Routes } from "../routes";
import { useSelector } from "react-redux";

// pages
import DevDashboard from "./dashboard/DevDashboard";
import Dashboard from "./dashboard/Dashboard";
import { UserChat } from "./userChat";
import { SupplierDetail, Suppliers } from "./suppliers";
import { KycSubmitted, KycSubmittedDetail } from "./kycSubmitted";
import { InternalTransfers, InternalTransferDetailsPage } from "./payments/internalTransfer";

//Configurations
import { IncomingPaymentFees } from "./configurations/fees/IncomingPaymentFees";
import { OutgoingPaymentFees } from "./configurations/fees/OutgoingPaymentFees";
import { InternalTransferFees } from "./configurations/fees/InternalTransferFees";
import { MonthlyFees } from "./configurations/fees/MonthlyFees";
import { OtherFees } from "./configurations/fees/otherFees";
import { MarkupFees } from "./configurations/fees/markupFees";
import { FinancialAccounts } from "./configurations/financialAccounts";
import ForgotPassword from "./stb/ForgotPassword";
import ChangePassword from "./stb/ChangePassword";
import ResetPassword from "./stb/ResetPassword";
import Thankyou from "./stb/Thankyou";
import SignupThanks from "./stb/SingupThanks";
import Lock from "./stb/Lock";
import NotFoundPage from "./stb/NotFound";

// components
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";

import Authentication from "./stb/Authentication";
import QRDialog from "../components/QRDialog";
import FullLoader from "../components/loaders/FullLoader";
import { IncomingPayments } from "./payments/incoming";
import { OutgoingTransferListPage, OutgoingTransferPage, OutgoingTransferDetailsPage } from "./outgoingTransfer";
import {
  GlobalBeneficiariesListPage as BeneficiariesListPage,
  GlobalBeneficiaryCreatePage as BeneficiaryCreatePage,
  GlobalBeneficiaryEditPage as BeneficiaryEditPage,
  GlobalBeneficiaryDetailsPage as BeneficiaryDetailsPage,
} from "./beneficiaries";
// CONTRACT MODULE - COMMENTED OUT
// import ProgrammedLiens from "./programmedLiens/ProgrammedLiens";
import { TransactionChargesReport } from "./reports/transactionChargesReport";
import { LienReport } from "./reports/lienReport";
import { InvoiceReceipts } from "./InvoiceReceipts";
import InvoiceReceiptsDetails from "./InvoiceReceipts/invoiceReceiptsDetails";
// import ContractDetails from "./programmedLiens/contractDetails";
import MasterTransactionReport from "./reports/masterTransactionReports/masterTransactionReports";
import FeeIncomeReport from "./reports/feeIncomeReport/FeeIncomeReport";
import MonthlyPaymentFeeReport from "./reports/monthlyPaymentFeeReport/monthlyPaymentFeeReport";
import MonthlyFeeCollectionReport from "./reports/monthlyFeeCollectionReport/MonthlyFeeCollectionReport";
import OutwardRemittance from "./payments/outward/OutwardRemittance";
import { RemittanceDetails } from "./payments/remittanceDetails";
import CustomerFeeGroup from "./configurations/fees/customerFeeGroup/CustomerFeeGroup";
import FeeGroupCustomerList from "./configurations/fees/customerFeeGroup/FeeGroupCustomerList";
import CustomerPaymentFees from "./configurations/fees/customerPaymentFees/customerPaymentFees";
import ContractPaymentFees from "./configurations/fees/ContractPaymentFees/ContractPaymentFees";
import CountryWiseFeeGroup from "./configurations/fees/countryWiseFeeGroup/countryWiseFeeGroup";
import OnboardingStatisticsReport from "./reports/onboardingStatisticsReport/onboardingStatisticsReport";
import StbIpusaTransactionLog from "./reports/stbIpusaTransactionLog/stbIpusaTransactionLog";
import KycReport from "./reports/kycReport/kycReport";
import MakerCheckerUsers from "./makerCheckerUsers/makerCheckerUsers";
import { AccountStatementPage } from "./accountStatement";


const RouteWithLoader = ({ component: Component, checkAuth, ...rest }) => {
  const history = useHistory();

  if (checkAuth) {
    const token = localStorage.getItem("accessToken");
    if (token) {
      history.push(Routes.KycSubmitted.path);
    }
  }

  return (
    <Route
      {...rest}
      render={(props) => (
        <>
          <Component {...props} />{" "}
        </>
      )}
    />
  );
};

const RouteWithSidebar = ({
  component: Component,
  showSidebar,
  ...rest
}) => {
  const [showQRDialog, setShowQRDialog] = useState(false);

  let token = localStorage.getItem("accessToken");

  if (!token) {
    return <Redirect to={Routes.Signin.path} />;
  }

  const handleQRDialog = () => {
    setShowQRDialog(!showQRDialog);
  };

  return (
    <Route
      {...rest}
      render={(props) => {
        return (
          <>
            <Sidebar />
            <main className={`content ${!showSidebar ? "content-expand" : ""}`}>
              <Navbar handleQRDialog={handleQRDialog} />
              <Component {...props} />
              <QRDialog open={showQRDialog} handleClose={handleQRDialog} />
            </main>
          </>
        );
      }}
    />
  );
};

export default () => {
  const { showSidebar } = useSelector((state) => state.configReducer);
  const location = useLocation();

  return (
    <Switch>
      <RouteWithLoader
        exact
        path={Routes.Signin.path}
        checkAuth
        component={Authentication}
      />
      <RouteWithLoader
        exact
        path={Routes.ForgotPassword.path}
        component={ForgotPassword}
      />
      <RouteWithLoader
        exact
        path={`${Routes.ChangePassword.path}/`}
        component={ChangePassword}
      />
      <RouteWithLoader
        exact
        path={Routes.ResetPassword.path}
        component={ResetPassword}
      />
      <RouteWithLoader exact path={Routes.Thankyou.path} component={Thankyou} />
      <RouteWithLoader
        exact
        path={Routes.Signupthanks.path}
        component={SignupThanks}
      />
      <RouteWithLoader exact path={Routes.Lock.path} component={Lock} />
      <RouteWithLoader
        exact
        path={Routes.NotFound.path}
        component={NotFoundPage}
      />

      {/* pages */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.DashboardOverview.path}
        component={Dashboard}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.ReportTransactions.path} component={ReportTransactions}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.Suppliers.path}
        component={Suppliers}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.SupplierDetail.path}
        component={SupplierDetail}
      /> */}
      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.KycSubmitted.path}
        component={KycSubmitted}
      />
      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.KycSubmittedDetail.path}
        component={KycSubmittedDetail}
      />
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.OutgoingTransfer.path} component={OutgoingTransferListPage}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.OutgoingTransferList.path} component={OutgoingTransferListPage}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.OutgoingTransferCreate.path} component={OutgoingTransferPage}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.OutgoingTransferDetails.path} component={OutgoingTransferDetailsPage}
      /> */}
      {/* Beneficiaries Routes */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.Beneficiaries.path} component={BeneficiariesListPage}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.BeneficiariesList.path} component={BeneficiariesListPage}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.BeneficiariesCreate.path} component={BeneficiaryCreatePage}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.BeneficiariesEdit.path} component={BeneficiaryEditPage}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.BeneficiariesDetails.path} component={BeneficiaryDetailsPage}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.TransactionChargesReport.path} component={TransactionChargesReport}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.MasterTransactionReport.path} component={MasterTransactionReport}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.KycReport.path} component={KycReport}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.AccountStatement.path} component={AccountStatementPage}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.OnboardingStatisticsReport.path} component={OnboardingStatisticsReport}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.FeeIncomeReport.path} component={FeeIncomeReport}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.MonthlyPaymentFeeReport.path} component={MonthlyPaymentFeeReport}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.MonthlyFeeCollectionReport.path} component={MonthlyFeeCollectionReport}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.LienReport.path} component={LienReport}
      />
      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.AverageBalancesReport.path} component={LienReport}
      /> */}

      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.IncomingPayment.path} component={IncomingPayments}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.InternalTransfer.path} component={InternalTransfers}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.InternalTransferDetails.path} component={InternalTransferDetailsPage}
      /> */}

      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.IncomingTransfer.path} component={InvoiceReceipts}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.IncomingTransferDetailView.path} component={InvoiceReceiptsDetails}
      /> */}
      {/* CONTRACT ROUTES - COMMENTED OUT */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.ProgrammedLiens.path} component={ProgrammedLiens}
      />
      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.ProgrammedLiensDetailView.path} component={ContractDetails}
      /> */}

      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.FinancialAccounts.path} component={FinancialAccounts}
      /> */}

      {/* Configurations */}

      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.IncomingPaymentFees.path} component={IncomingPaymentFees}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.OutgoingPaymentFees.path} component={OutgoingPaymentFees}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.InternalTransferFees.path} component={InternalTransferFees}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.MonthlyFees.path} component={MonthlyFees}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.MarkupFees.path} component={MarkupFees}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.CustomerPaymentFees.path} component={CustomerPaymentFees}
      />
      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.ContractPaymentFees.path} component={ContractPaymentFees}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.OtherFees.path} component={OtherFees}
      /> */}

      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        path={Routes.UserChat.path} component={UserChat}
      /> */}

      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.UserChatGeneral.path} component={UserChat}
      /> */}

      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.OutwardRemittance.path} component={OutwardRemittance}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.OutwardRemittanceDetails.path} component={RemittanceDetails}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.CustomerFeeGroup.path} component={CustomerFeeGroup}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.CustomerFeeGroupDetail.path} component={FeeGroupCustomerList}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.CountryWiseFeeGroup.path} component={CountryWiseFeeGroup}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.StbIpusaTransactionLog.path} component={StbIpusaTransactionLog}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.MakerCheckerUsers.path} component={MakerCheckerUsers}
      /> */}

      {/* 
      
      
      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.IncomingPaymentReport.path} component={InwardRemittanceReport}
      />
      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.SenderBusinessClients.path} component={SenderBusinessClients}
      />
      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.SenderIndividualClients.path} component={SenderIndividualClients}
      />
      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.ClientsSenderDetails.path} component={ClientsSenderDetails}
      />

      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.ReceiverBusinessClients.path} component={ReceiverBusinessClients}
      />

      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.Deposits.path} component={Deposits}
      />

      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.DepositsHistory.path} component={DepositsHistory}
      />

      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.ReceiverIndividualClients.path} component={ReceiverIndividualClients}
      />
      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.UserKyc.path} component={UserKyc}
      />

      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.UserKybDetails.path} component={UserKybDetail}
      />

        */}

      {/* Remittance */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.OutwardRemittance.path} component={OutwardRemittance}
      />
      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.ClientRemittance.path} component={CustomerCreatedRemittance}
      />

      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.AddOutwardRemittance.path} component={AddRemittance}
      />

      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.OutwardRemittanceDetails.path} component={RemittanceDetails}
      />

      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.EditDraftRemittance.path} component={AddRemittance}
      />
      

      
      

      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.IncomingPaymentDetails.path} component={RemittanceDetails}
      /> */}

      {/* REDEMPTIONS */}

      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.AvailableRedemptions.path} component={AvailableRedemptions}
      />
      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.RedemptionsRaised.path} component={RedemptionRequestRaised}
      />
      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.CreateRedeemRequest.path} component={CreateRedeemRequest}
      />
      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.RedemptionsReceived.path} component={RedemptionRequestReceived}
      />
      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.RedemptionRaisedDetails.path} component={RedemptionDetails}
      />
      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.RedemptionReceivedDetails.path} component={RedemptionDetails}
      /> */}

      {/* Configurations */}
      {/* 

      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.ExchangeOffers.path} component={ExchangeOffers}
      />
      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.ExchangeOfferHistory.path} component={ExchangeOfferHistory}
      />
      
      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.KycLevels.path} component={KycLevels}
      />

      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.SubAccounts.path} component={SubAccounts}
      />

      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.LiquidityHistory.path} component={LiquidityHistory}
      />
      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.Liquidity.path} component={Liquidity}
      />

      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.AccountBalance.path} component={AccountBalance}
      /> */}

      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.Statement.path}
        component={Statement}
      /> */}

      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.TotalPaymentsReport.path}
        // isAllowed={true} component={TotalPaymentsReport}
      /> */}

      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.MTOLedgerDetails.path}
        // isAllowed={true} component={MtoLedgerDetails}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.WalletMovement.path}
        // isAllowed={true} component={WalletMovement}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.MTOLedgerSummary.path}
        // isAllowed={true} component={MtoLedgerSummary}
      /> */}
      {/* 

      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.AvailableRedemptionReport.path}
        // isAllowed={true} component={AvailableRedemptionReport}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.History.path}
        component={History}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.SystemUser.path} component={SystemUser}
      /> */}
      {/* <RouteWithSidebar showSidebar={showSidebar} */}
      {/* <RouteWithSidebar showSidebar={showSidebar}
      exact
      path={Routes.AddSystemUser.path}
      component={AddSystemUser}
    /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.UserApproval.path}
        component={UserApproval}
      /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.BusinessDetails.path}
        component={BusinessDetails}
      />
      <RouteWithSidebar
        showSidebar={showSidebar}
        // <RouteWithSidebar showSidebar={showSidebar}
        exact
        path={Routes.CounterMenu.path}
        component={Counter}
      />
      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.StoreMenu.path}
        component={StoreMenu}
      /> */}
      {/* <RouteWithSidebar showSidebar={showSidebar} exact path={Routes.BusinessDetailsEdit.path} component={BusinessDetailsEdit} /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.Invoices.path}
        component={Invoices}
      />
      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.Customer.path}
        component={Customer}
      />
      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.CustomerDetails.path}
        component={CustomerDetails}
      />

      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.Support.path} component={Support}
      /> */}
      {/* <RouteWithSidebar showSidebar={showSidebar}
      exact
      path={Routes.NewTicket.path}
      component={NewTicket}
    /> */}
      {/* <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.TicketReply.path} component={TicketReply}
      />
      <RouteWithSidebar
        showSidebar={showSidebar}
        exact
        path={Routes.Profile.path} component={Settings}
      /> */}

      <Route
        exact
        path="/"
        render={() => <Redirect to={Routes.KycSubmitted.path} />}
      />
      <Redirect to={Routes.NotFound.path} />
    </Switch>
  );
};

